import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// Guards /admin/* routes: shows nothing while auth resolves, redirects to the
// admin login if not signed in or not an admin.
export default function RequireAdmin({ children }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream text-olive" data-testid="admin-auth-loading">
        <div className="animate-pulse text-sm tracking-[0.2em] uppercase">Checking access…</div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }

  return children;
}
